import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Select } from '@ngxs/store';
import { AnyNsRecord } from 'dns';
import { Observable, Subscription } from 'rxjs';
import { PictogrammeDto } from 'src/api/models';
import { ControlPanelStore } from 'src/states/control-panel.store';
import { LoaderService } from '../../loader/loader.service';

@Component({
  selector: 'app-pictogramme',
  templateUrl: './pictogramme.component.html',
  styleUrls: ['./pictogramme.component.css']
})
export class PictogrammeComponent implements OnInit, OnDestroy {
  @Select(ControlPanelStore.pictogrammes$) pictogrammes$: Observable<PictogrammeDto[]>;

  Image: any;
  Pictogrammes: PictogrammeDto[] = [];
  PictogrammeInComponent: PictogrammeDto;

  @Input() height: number;

  private _pictogrammeId: number = null
  @Input()
  get pictogrammeId() {
    return this._pictogrammeId;
  }
  set pictogrammeId(val) {
    this._pictogrammeId = val;
    this.getPictogrammeInComponent();
  }

  @Input('image') public image: string;

  p: Subscription;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.p = this.pictogrammes$.subscribe(res => {
      if (res != null) {
        this.Pictogrammes = res;
        if (this.pictogrammeId != null) {
          let pictogrammes = this.Pictogrammes.filter(t => t.Id == this.pictogrammeId);
          this.PictogrammeInComponent = pictogrammes.length == 1 ? pictogrammes[0] : { Nom: null, Image: null };
          if (this.PictogrammeInComponent.Image != null) {
            this.CreateImageFromBytes(this.PictogrammeInComponent.Image);
          }
        } else if (this.image != null) {
          this.CreateImageFromBytes(this.image);
        }
        else {
          this.Image = null;
        }
      }
    });
  }

  getPictogrammeInComponent() {
    if (this.pictogrammeId != null) {
      let pictogrammes = this.Pictogrammes.filter(t => t.Id == this.pictogrammeId);
      this.PictogrammeInComponent = pictogrammes.length == 1 ? pictogrammes[0] : { Nom: null, Image: null };
      if (this.PictogrammeInComponent.Image != null) {
        this.CreateImageFromBytes(this.PictogrammeInComponent.Image);
      }
    }
  }

  CreateImageFromBytes(image: any) {
    let objectURL = 'data:image/png;base64,' + image;
    this.Image = this.sanitizer.bypassSecurityTrustUrl(objectURL);
  }

  isHeightInput() {
    return this.height == null;
  }

  styleImage() {
    if (!!this.height) {
      return { 'height': this.height+'px' };
    }
    return { 'height': '50px' };
  }

  ngOnDestroy() {
    this.p?.unsubscribe();
  }
}
